import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    name: data?.name || "",
    email: data?.email || "",
    status: data?.status || "active",
    phone_number: data?.phone_number
      ? `+${data?.country_code}${data?.phone_number}`
      : "",
    country_code: data?.country_code ? `+${data?.country_code}` : "",
    password: "",
    password_confirmation: "",
  };
};

export const structure = ({ id, t }) => [
  {
    head: t("employees.employee_details") || "Employee Details",
    width: "100%",
    list: [
      {
        name: "name",
        kind: "input",
        type: "text",
        label: t("employees.label_name") || "Employee Name*",
        width: "47%",
        placeholder: t("employees.placeholder_name") || "Write employee name",
      },
      {
        name: "email",
        kind: "input",
        type: "email",
        label: t("vendors.label_email") || "Email*",
        width: "47%",
        placeholder: t("vendors.placeholder_email") || "Write Email",
      },
      {
        name: "phone_number",
        kind: "phone",
        type: "text",
        label: t("employees.label_phone") || "Phone Number*",
        width: "47%",
        placeholder: t("employees.placeholder_phone") || "Write Phone Number",
      },
      id && {
        name: "status",
        kind: "select",
        type: "text",
        label: t("employees.label_status") || "Status*",
        width: "47%",
        placeholder: t("employees.placeholder_status") || "Choose Status",
        options: [
          { id: "active", name: t("employees.status_active") || "Active" },
          {
            id: "deactivated",
            name: t("employees.status_deactivated") || "Deactivated",
          },
        ],
      },
      {
        name: "password",
        kind: "input",
        type: "password",
        label: id
          ? t("employees.label_new_password") || "New Password"
          : t("employees.label_password") || "Password*",
        width: "47%",
        placeholder: t("employees.placeholder_password") || "Write Password",
      },
      {
        name: "password_confirmation",
        kind: "input",
        type: "password",
        label: id
          ? t("employees.label_confirm_new_password") || "Confirm New Password"
          : t("employees.label_confirm_password") || "Confirm Password*",
        width: "47%",
        placeholder:
          t("employees.placeholder_confirm_password") || "Confirm Password",
      },
    ].filter(Boolean),
  },
];

export const validationSchema = (formikValues, id, t) =>
  Yup.object({
    name: Yup.string().required(t("common.required") || "required"),
    email: Yup.string()
      .required(t("common.required") || "required")
      .email()
      .label("Email"),
    status: id
      ? Yup.string().required(t("common.required") || "required")
      : Yup.string(),
    phone_number: Yup.string().required(t("common.required") || "required"),
    password: !id
      ? Yup.string()
          .required(t("common.required") || "required")
          .min(
            6,
            t("employees.password_min") ||
              "password can be at least 6 characters",
          )
      : Yup.string().min(
          6,
          t("employees.password_min") ||
            "password can be at least 6 characters",
        ),
    password_confirmation: !id
      ? Yup.string()
          .required(t("common.required") || "required")
          .oneOf(
            [Yup.ref("password"), null],
            t("employees.password_mismatch") || `Passwords don't match`,
          )
      : Yup.string().oneOf(
          [Yup.ref("password"), null],
          t("employees.password_mismatch") || `Passwords don't match`,
        ),
  });
